import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class TrainingTypeServices {
  getTrainingType = params =>
    AxiosClient.get("/api/app/capacitacion_tipo_capacitacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
  getTrainingTypeById = id =>
    AxiosClient.get(`/api/app/capacitacion_tipo_capacitacion/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveTrainingType = data =>
    AxiosClient.post("/api/app/capacitacion_tipo_capacitacion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editTrainingType = (id, data) =>
    AxiosClient.put(
      `/api/app/capacitacion_tipo_capacitacion/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteTrainingType = id =>
    AxiosClient.delete(`/api/app/capacitacion_tipo_capacitacion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new TrainingTypeServices();